import showUnsavedChangesConfirmationSelector from 'app/App/selectors/showUnsavedChangesConfirmation';
import connect from 'utils/store/connect';

import { hideUnsavedChangesConfirmationModal } from './actions';
import UnsavedChangesConfirmationModal from './components/UnsavedChangesConfirmationModal';
import { onDiscardThunk, onSaveThunk } from './thunks';

/**
 * Return object mapping state to prop
 * @param {object} state - Redux state object
 * @returns {object} Object for react props
 */
const mapStateToProps = state => ({
  showUnsavedChangesConfirmation: showUnsavedChangesConfirmationSelector(state)
});

const mapDispatchToProps = {
  onCancel: hideUnsavedChangesConfirmationModal,
  onDiscard: onDiscardThunk,
  onSave: onSaveThunk
};

export default connect(mapStateToProps, mapDispatchToProps)(UnsavedChangesConfirmationModal);
